import { merchantListConstants } from "./merchantList.constants";

export const merchantListActions = {
	resetMerchantState,
};

function resetMerchantState() {
	return { type: merchantListConstants.RESET_MERCHANT_INFO_STATE };
}
